import React from 'react';
import {useTranslation} from 'react-i18next';
import {useFeaturesStatuses} from 'hooks';
import {useSummary} from 'context/summary';
import {useSchema} from 'context/guest';
import {FEATURE_STATUSES} from 'utils/constants';

function useBuildTasksItems() {
  const {t} = useTranslation();
  const {data: summary} = useSummary();
  const {verification, registerGuests, deposit, touristTaxes} = useFeaturesStatuses();
  const {
    identityVerificationDetails: {enabled: ivEnabled, required: ivRequired},
  } = useSchema();
  const [completedTasks, setCompletedTasks] = React.useState(0);
  const [percentage, setPercentage] = React.useState(0);

  const items = React.useMemo(() => {
    return [
      {
        label: t('register_all_guests'),
        completed: registerGuests === FEATURE_STATUSES.complete,
        active: true,
      },
      {
        label: t('complete_deposit'),
        completed: deposit === FEATURE_STATUSES.complete,
        active: summary?.property_protection.active,
      },
      {
        label: t('pay_turist_taxes'),
        completed: touristTaxes === FEATURE_STATUSES.complete,
        active: summary?.taxes.active,
      },
      {
        label: t('identity_verification'),
        completed: verification === FEATURE_STATUSES.complete,
        active: ivEnabled && ivRequired,
      },
    ];
  }, [
    summary,
    ivEnabled,
    ivRequired,
    t,
    verification,
    registerGuests,
    deposit,
    touristTaxes,
  ]);

  React.useEffect(() => {
    const activeItems = items.filter(i => i.active);
    const completeItems = activeItems.filter(i => i.completed);
    setCompletedTasks(completeItems.length);
    setPercentage((completeItems.length / activeItems.length) * 100);
  }, [items]);

  return {items, completedTasks, percentage};
}

export default useBuildTasksItems;
